import React from "react";

export interface ChevronDownProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
  className?: string;
}

export const ChevronDown: React.FC<ChevronDownProps> = ({
  width = 18,
  height = 18,
  fill = "currentColor",
  className,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 438 266"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path d="M202.029 258.476L7.686 64.1317C-1.687 54.7587-1.687 39.5627 7.686 30.1907L30.353 7.52366C39.71 -1.83334 54.875 -1.85135 64.254 7.48365L219 161.505L373.745 7.48365C383.124 -1.85135 398.289 -1.83334 407.646 7.52366L430.313 30.1907C439.686 39.5637 439.686 54.7597 430.313 64.1317L235.971 258.476C226.598 267.848 211.402 267.848 202.029 258.476Z" />
  </svg>
);
